<template>
    <vx-card>
      <vs-table id="studentsTable" sst multiple pagination search
                v-model="selected" :total="total"
                @change-page="getPage" @sort="getSort" @search="getSearch" @max-items="getMaxItems"
                :max-items="maxItems" class="my-5" no-data-text="لا يوجد طلبة" :data="students">

        <div slot="header" class="flex flex-wrap justify-between">
          <input @change="importExcel" type="file" accept=".xlsx, .xls" class="hidden" ref="import" />
          <div class="flex flex-wrap">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <vs-button icon="icon-chevron-down" icon-pack="feather" icon-after class="lg:mt-0 mt-4">ملف xlsx</vs-button>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="$refs.import.click()">تحميل</vs-dropdown-item>
                <vs-dropdown-item @click="exportExcel">إستخراج</vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <vs-button v-if="hasRole('add_students')" color="success" icon-pack="feather" icon="icon-plus" class="ml-3 lg:mt-0 mt-4" icon-after @click="openStudentForm">إضافة</vs-button>
            <vs-button v-if="hasRole('delete_students') &&selected.length >= 2" color="danger" icon-pack="feather" icon="icon-trash" class="lg:ml-3 ml-0 lg:mt-0 mt-4" icon-after @click="deleteSelected" >حذف المحدد  {{selected.length}}</vs-button>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="std_id" >رقم القيد</vs-th>
          <vs-th sort-key="first_name">إسم الطالب</vs-th>
          <vs-th sort-key="middle_name">إسم الأب</vs-th>
          <vs-th sort-key="last_name">اللقب</vs-th>
          <vs-th sort-key="email">البريد الإلكتروني</vs-th>
          <vs-th sort-key="status">الحالة</vs-th>
          <vs-th sort-key="created_at">تاريخ التسجيل</vs-th>
          <vs-th>العمليات</vs-th>
        </template>

        <tbody slot-scope="{data}">
        <vs-tr v-for="(tr, index) in data" :data="tr" :key="index">
          <vs-td :data="tr.std_id">{{ tr.std_id }}</vs-td>
          <vs-td :data="tr.first_name">{{ tr.first_name }}</vs-td>
          <vs-td :data="tr.middle_name">{{ tr.middle_name }}</vs-td>
          <vs-td :data="tr.last_name">{{ tr.last_name }}</vs-td>
          <vs-td :data="tr.email">
            <div class="flex items-center">
              {{ tr.email }}
              <vx-tooltip :text="tr.is_verified ? 'البريد الإلكتروني مؤكد' : 'البريد الإلكتروني غير مؤكد'" class="cursor-pointer ml-2">
                <vs-icon :icon="tr.is_verified ? 'icon-check' : 'icon-x'" icon-pack="feather"
                         :class="tr.is_verified ? 'bg-success' : 'bg-danger'"
                         class="rounded-full p-px h-3 w-3 text-white"/>
              </vx-tooltip>
              <span v-if="!tr.is_verified && !tr.emailSend" @click="resendEmail(tr)" class="ml-2 text-primary cursor-pointer">إعادة إرسال</span>
            </div>
          </vs-td>
          <vs-td :data="tr.status">
            <vs-chip v-if="tr.status === 0" color="warning">قيد الانتظار</vs-chip>
            <vs-chip v-else-if="tr.status === 1" color="success">مفعل</vs-chip>
            <vs-chip v-else color="danger">موقوف</vs-chip>
          </vs-td>
          <vs-td>{{ tr.created_at | reg_date }}</vs-td>
          <vs-td>
            <div class="flex">
              <template v-if="hasRole('update_students')">
                <vs-button :to="{name: 'studentCourses', params: {student_id: tr.std_id}}" class="ml-2 d-inline" size="large" color="primary" type="flat" icon-pack="feather" icon="icon-book" title="المواد الدراسية" />
                <vs-button v-if="tr.status !== 1" size="large" title="تفعيل الحساب" color="success" type="flat" class="ml-2 d-inline" icon-pack="feather" icon="icon-check" @click="changeStatus(tr, 1)"></vs-button>
                <vs-button v-else size="large" title="إقاف الحساب" color="warning" type="flat" class="ml-2 d-inline" icon-pack="fa" icon="fa-ban" @click="changeStatus(tr, 2)"></vs-button>
                <vs-button @click="openStudentForm(tr)" size="large" title="تعديل" color="primary" type="flat" class="ml-2" icon-pack="feather" icon="icon-edit"></vs-button>
              </template>
              <vs-button v-if="hasRole('delete_students')" @click="deleteStudent(tr)" size="large" title="حذف" color="danger" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
            </div>
          </vs-td>
        </vs-tr>
        </tbody>

      </vs-table >

      <student-form @submit="saveStudent" :data="studentData" :active.sync="isStudentFormActive"/>
    </vx-card>
</template>

<script>
    import studentsAPI from '@/api/admin/studentsAPI'
    import StudentForm from '@/views/admin/students/StudentForm'
    import userAPI from '@/api/admin/userAPI'
    import fileAPI from '@/api/fileAPI'

    export default {
        components: { StudentForm },
        data() {
            return {
                selected: [],
                isStudentFormActive: false,
                students: [],
                studentData: {},
                studentEditIndex: -1,
                currentPage: 1,
                maxItems: 10,
                sortKey: 'std_id',
                sortType: 'asc',
                total: 0,
                search: '',
                searchTimeout: null,
                statusFilter: null,
            }
        },
        methods: {
            resendEmail(student){
              let message = `هل انت متأكد من أنك تريد إعادة ارسال رسالة تأكيد البريد الإلكتروني إلى "${student.email}"؟`
              this.$confirmAlert(null, message, () => {
                userAPI.resendEmail(student.user_id).then(response => {
                  student.emailSend = true;
                  this.$forceUpdate()
                  this.$notifySuccess(response.successMessage)
                }).catch(error => this.$notifyError(error.statusMessage))
              }, 'warning')
            },
            importExcel(event) {
                if(event.target.files){
                    const file = event.target.files[0]
                    if(!/\.(xlsx|xls|csv)$/.test(file.name)){
                        this.$notifyWarning('يجب ان يكون الملف من النوع Excel')
                        return;
                    }

                    const data = new FormData()
                    data.append('type', 'students')
                    data.append('file', file)
                    fileAPI.import(data).then(({data}) => {
                        this.$notifySuccess(`لقد تم إضافة ${data.length} طلبة بنجاح.`)
                        this.loadData()
                    })
                }
            },
            exportExcel() {
                studentsAPI.export()
            },
            getSort(key, type){
                this.sortKey = key
                this.sortType = type
                this.loadData()
            },
            getSearch(value){
                this.search = value
                clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                  this.loadData()
                  this.currentPage = 1
                  this.searchTimeout = null
                }, 500)
            },
            getPage(page){
                if(this.searchTimeout) return
                this.currentPage = page
                this.loadData()
            },
            getMaxItems(maxItems){
                this.maxItems = maxItems
                this.loadData()
            },
            openStudentForm(student){
                Object.assign(this.studentData = {}, student)
                this.studentEditIndex = this.students.indexOf(student)
                this.isStudentFormActive = true
            },
            saveStudent(student){
                this.studentEditIndex !== -1 ? this.$set(this.students, this.studentEditIndex, student) : this.students.unshift(student)
            },

            deleteStudent(student){
                let message =  'هل انت متأكد بأنك تريد حذف الطالب صاحب رقم القيد: ' + student.std_id;
                this.$confirmAlert(null, message, () => {
                    studentsAPI.delete(student.std_id)
                        .then(response => {
                            this.students.splice(this.students.indexOf(student), 1)
                            this.$notifySuccess(response.successMessage)
                        })
                        .catch(response => this.$notifyError(response.statusMessage))
                })
            },
            deleteSelected(){
                let message = 'هل انت متأكد من أنك تريد حذف المحدد ؟ '
                this.$confirmAlert(null, message, () => {
                    let students = this.selected.map(student => {return student})
                    let ids = students.map(student => {return student.user_id})

                    studentsAPI.deleteMulti(ids)
                        .then(response => {
                            students.forEach(student => this.$delete(this.students, this.students.indexOf(student)))
                            this.selected = []
                            this.$notifySuccess(response.successMessage)
                        })
                        .catch(error => this.$notifyError(error.statusMessage))
                })
            },
            changeStatus(student, status) {
                let doChange = () => {
                    userAPI.changeStatus(student.user_id, 'student', status)
                        .then(() => student.status = status)
                }
                if(status === 1){
                    doChange()
                    return
                }
                this.$confirmAlert(null, `هل انت متأكد بأنك تريد إقاف تفعيل حساب الطالب صاحب رقم القيد ${student.std_id}` , () => doChange(), 'warning')

            },
            loadData(){
                if(!this.sortKey) return
                this.$startLoading('#studentsTable', 'white')
                this.selected = []
                let filterData = {
                    sort_key: this.sortType ? this.sortKey : 'std_id',
                    sort_type: this.sortType ? this.sortType : 'asc',
                    page: this.currentPage,
                    search: this.search,
                    max_items: this.maxItems,
                    status: this.statusFilter
                }
                studentsAPI.getAllFiltered(filterData)
                    .then(({data}) => {
                      this.total = data.count
                      this.students = data.students
                    })
                    .finally(() => this.$closeLoading('#studentsTable'))
            }
        },
        mounted(){
            this.loadData()
        }
    }

</script>
